import { PencilIcon, Trash2 } from 'lucide-react';
import { ColumnDef } from '@tanstack/react-table';
import { DocumentCategoryQueryData } from '@area-restrita/api-client/model/documentCategoryQueryData';

import { Button } from '@/components/ui/button';
import Dialog from '@/components/template/Dialog';

import UpdateDocumentCategory from '../../components/update-document-category';
import { useAuthSessionStore } from '@/modules/authentication/stores/authSessionStore';

export type IDocumentCategory = DocumentCategoryQueryData;

export const columns: ColumnDef<IDocumentCategory>[] = [
  { accessorKey: 'description', header: 'Descrição' },
  {
    accessorKey: 'color',
    header: 'Cor',
    cell: ({ row }) => (
      <div
        className="w-8 h-8 rounded-md"
        style={{ backgroundColor: row.original.color }}
      />
    ),
  },
  {
    header: 'Ações',
    meta: { className: 'text-right' },
    cell: function ActionsCell({ row }) {
      const { checkAuthorization } = useAuthSessionStore();
      const canUpdate = checkAuthorization(({ can }) =>
        can('update', 'document_categories'),
      );

      return (
        <div className="flex justify-end gap-3">
          <Dialog
            title="Editar Categoria de Documento"
            trigger={
              <Button
                variant="outline"
                size="icon-sm"
                disabled={!row.original.editable || !canUpdate}
              >
                <PencilIcon className="h-4 w-4" />
              </Button>
            }
          >
            <UpdateDocumentCategory
              documentCategoryId={row.original.id}
              defaultValues={row.original}
            />
          </Dialog>

          <Button
            variant="destructive"
            size="icon-sm"
            disabled={!row.original.editable}
            className="hidden"
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      );
    },
  },
];
